<div class="container nested">
  <div class="row">
    <div class="col-md-7">
      <app-promo-banner style="margin-bottom: 16px"></app-promo-banner>
      <ng-container *ngIf="teamsLoading === false; else loadingIndicator">
        <ng-container *ngIf="club; else noClubFound">
          <lib-section-header title="Alle Mannschaften"
                              titleIcon="stadium"
          ></lib-section-header>

          <div class="team-cell" *ngFor="let team of teams">
            <app-team-cell
              [currentUser]="currentUser" [team]="team"
              (onFollowClick)="toggleFollow(true, $event)"
              (onUnfollowClick)="toggleFollow(true, $event)"
            ></app-team-cell>
          </div>
        </ng-container>
        <ng-template #noClubFound>
          <lib-section-header title="Alle Mannschaften"
                              titleIcon="stadium"
          ></lib-section-header>

          <p class="no-infos-available">Keine weiteren Mannschaften bekannt</p>
        </ng-template>
      </ng-container>
      <ng-template #loadingIndicator>
        <div class="container mb-5 mt-5">
          <mat-spinner strokeWidth="2" color="primary" diameter="54" class="m-auto"></mat-spinner>
        </div>
      </ng-template>
    </div>

    <div class="col-md-5">
      <lib-ad class="col-12 mt-2"></lib-ad>
    </div>
  </div>
</div>
